import React from 'react'
import "./SearchContainer.css"
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux';
function SearchContainer({ searchkey, products,categories }) {
      const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <div className='mt-4'>
      <Container fluid>
        <Row>

          {products?.length !== 0 &&
            <Col md={6}>
              <h6>{currentLocal.home.products}</h6>
              {products && products?.map((item, index) => {
                console.log(item);
                
                return (
                  <Link className='d-flex align-items-center mt-2'key={index} to={`/product/${item.id}`}>
                    <img src={item?.images[0]?.image} alt="" className="w-25 me-1" />

                    <p className='mb-0'>{currentLocal.language=="English"?item?.name_en:item?.name_ar}</p>
                  </Link>

                )
              })}


            </Col>
          }
        </Row>
      </Container>

    </div>
  )
}

export default SearchContainer